import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar";
import {
  JSXElementConstructor,
  Key,
  ReactElement,
  ReactNode,
  ReactPortal,
  useState,
  useEffect,
} from "react";
import useAdGeneralConf from "../../hooks/ad-hooks/useAdGeneralConf.hook";

const PublicidadView = () => {
  const navigate = useNavigate();
  const { loaders, data, actions } = useAdGeneralConf();

  useEffect(() => {
    actions.fetchAds();
  }, []);

  const goBack = () => {
    navigate(-1);
  };

  const newAd = () => {
    navigate("/advertising-form");
  };

  const handleEdit = (id: number) => {
    // Navegar al formulario con el ID para editar
    navigate(`/advertising-form/${id}`);
  };

  const handleDelete = async (id: number) => {
    await actions.deleteAdById(id);
  };


  return (
    <div className="background-colored">
      <div className="row justify-content-center">
        <div className="col-12 col-sm-2 justify-content-center sidebar">
          <Sidebar />
        </div>
        <div className="col-12 col-sm-9 justify-content-center datatable-container ml">
          <div className="header-container">
            <div>
              {/* <a className="arrow" onClick={goBack}>
                <i className="fa fa-arrow-left" aria-hidden="true"></i>
              </a> */}
              <span id="customized" className="header-label">
                Publicidad{" "}
              </span>
            </div>
            <button className="btn btn-primary-custom" onClick={newAd}>
              Crear nuevo
            </button>
          </div>
          <div className="mt-4 scroll-container">
            <table className="table table-striped text-center">
              <thead>
                <tr>
                  <th scope="col" className="th">
                    Nombre
                  </th>
                  <th scope="col" className="th">
                    Categoría
                  </th>
                  <th scope="col" className="th">
                    Auspiciante
                  </th>
                  <th scope="col" className="th">
                    Peso
                  </th>
                  <th scope="col" className="th">
                    Estado
                  </th>
                  <th scope="col" className="th">
                    URL
                  </th>
                  <th scope="col" className="th">
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                {loaders.isLoadingData ? (
                  <tr>
                    <td colSpan={7} className="text-center">
                      <div className="spinner-border" role="status">
                        <span className="sr-only"></span>
                      </div>
                    </td>
                  </tr>
                ) : data.ads.length > 0 ? (
                  data.ads.map((ad) => (
                    <tr key={ad.id}>
                      <td>{ad.nombre}</td>
                      <td className="text-capitalize">{ad.categoria}</td>
                      <td>{ad.auspiciante.nombre}</td>
                      <td>{ad.peso}</td>
                      <td>
                        <span
                          className={`badge ${ad.activo ? 'bg-success' : 'bg-danger'}`}
                        >
                          {ad.activo ? 'Activo' : 'Inactivo'}
                        </span>
                      </td>
                      <td>
                        <a
                          href={ad.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-link btn-sm"
                        >
                          {ad.url}
                        </a>
                      </td>
                      <td>
                        <button
                          className="btn btn-warning btn-sm me-2"
                          onClick={() => handleEdit(ad.id!)}
                          title="Editar"
                        >
                          <i className="fa fa-edit"></i>
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(ad.id!)}
                          title="Eliminar"
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center text-muted">
                      No hay anuncios disponibles
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicidadView;
